export const API_URL=  "https://test.electionnigeria.live/"

export const SECRET_KEY = "1234"

export const MAP_API_KEY = "AIzaSyCS-jRLSrbzWY0cSZrQcg1zdjBAAjm27dE"

export const FILE_PATH = "https://electionuploads104030-dev.s3.eu-west-1.amazonaws.com/public/"